import Base from "./Base";

class Comments extends Base {
    static save(body) {
        return this.sendRequest("/comments/save", "POST", {}, body);
    }
    static getComments(params){
        return this.sendRequest("/comments/get-comments", "GET", params);
    }
    static delete(params){
        return this.sendRequest("/comments/delete", "GET", params);
    }
    static getListMentions(params){
        return this.sendRequest("/list/get-list-mentions", "GET", params);
    }
}

export default Comments;